import React, { Suspense,useEffect } from "react";
// import { BrowserRouter, Route, Routes } from "react-router-dom";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { pvrTheme, inoxTheme } from "./theme/themes";
import PAYMENT from "./views/payment/Payment";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css"; //icons
import "bootstrap/dist/css/bootstrap.min.css";
import "./custom-style/style.css"; // == global styling
import "./custom-style/queries.css"; // == global styling
import "./custom-style/mobilequeries.css"; // == global styling
import { cinemaChain } from "./constants";
import { HelmetProvider, Helmet } from "react-helmet-async";
import ReactGA from "react-ga";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);


function includeRecaptcha() {
  const script = document.createElement('script');
  script.src = 'https://www.google.com/recaptcha/api.js?render=6Lc_edEqAAAAAOz-ftKFlLck5WCfl5Bdjnr_UwcV';
  script.async = true;
  document.body.appendChild(script);
  const style = document.createElement("style");
  style.innerHTML = `
    .grecaptcha-badge {
      visibility: hidden !important;
    }
  `;
  document.head.appendChild(style);


  return () => {
      document.body.removeChild(script);
      document.head.removeChild(style);

  };

}


// ==== mobile views pages end rountes ============

const Home = React.lazy(() => import("./views/home/Home"));
const PROFILE = React.lazy(() => import("./views/passport/Profile"));
const Activate = React.lazy(() => import("./views/passport/Activate"));
const Voucher = React.lazy(() => import("./views/passport/Voucher"));
const MPROFILE = React.lazy(() => import("./views/passport/MobileProfile"));
const MHOME = React.lazy(() => import("./views/passport/MobileHome"));
const MobilePayment = React.lazy(() =>
  import("./views/mobile-views/mobile-payment/MobilePayment")
);
const PassportTnc = React.lazy(() => import("./views/passport/Tnc"));

const FAQS = React.lazy(() => import("./views/passport/Faqs"));




function App() {
  useEffect(includeRecaptcha, []);
  const themeVal = cinemaChain === "PVR" ? "pvrTheme" : "inoxTheme";
  localStorage.setItem("theme", themeVal);
  const theme = cinemaChain === "PVR" ? pvrTheme : inoxTheme;
  if (cinemaChain === "PVR") ReactGA.initialize("G-CPXWTKDXV8");
  else ReactGA.initialize("G-FYEYSCFLNJ");

  // localStorage.setItem("city", "Delhi-NCR");
  if (!localStorage.getItem("lat")) {
    localStorage.setItem("lat", "0.000");
    localStorage.setItem("long", "0.000");
  }
  const Ticket = React.lazy(() => import("./views/final-ticket/FinalTicket"));
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet>
          <title>{cinemaChain === "PVR" ? "PVR Passport" : "INOX Passport"}</title>
          <link
            rel="icon"
            href={cinemaChain === "PVR" ? "/pvr.ico" : "/inox.ico"}
          />
          <meta name="description" content="PVR INOX" />
        </Helmet>
        <ThemeProvider theme={theme}>
          {/* <BrowserRouter> */}
          <Suspense fallback={loading}>
            <Router>
              <Routes>
                <Route path="/" name="Home" element={<Home />} />
                <Route path="/faqs" name="FAQS" element={<FAQS />} />
                <Route path="/terms" name="Tnc" element={<PassportTnc />} />

                <Route path="/passport-profile" name="Passport Profile" element={<PROFILE />} />
                <Route path="/activate" name="Activate" element={<Activate />} />
                <Route
                  path="/payment/:cinemaname"
                  element={<PAYMENT />}
                ></Route>
                <Route
                  path="/passport-ticket"
                  name="Movie Ticket"
                  element={<Ticket />}
                />
                <Route path="/voucher" name="Voucher" element={<Voucher />} />
                <Route path="/mobile-home" name="Voucher" element={<MHOME />} />
                <Route path="/mobile-profile" name="Voucher" element={<MPROFILE />} />
                <Route
                  path="/m.payment/:cinemaname"
                  name="Payment"
                  element={<MobilePayment />}
                />
                <Route path="cinema/:cinemacode?" name="Home" element={<Home />} />
              </Routes>
            </Router>
          </Suspense>
          {/* </BrowserRouter> */}
        </ThemeProvider>
      </HelmetProvider>
    </React.Fragment>
  );
}

export default App;
